import { UserRoles } from '../../../models/user/user.types';

export type Commercial = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  siret: string;
  tva: string | null;
  city: string;
  department: string;
  region: string;
  id_step: number;
  is_enabled: boolean;
  type: CommercialTypes;
  role: UserRoles.Commercial;
};

export enum CommercialTypes {
  Employee = 'Interne',
  Independent = 'Indépendent'
}